import { ThemeProvider } from '@emotion/react';
import { Outlet, useLocation } from 'react-router-dom';
import { createTheme, CssBaseline } from '@mui/material';
import { useState } from 'react';

const orangeTheme = {
  typography: {
    fontFamily: 'Spiegel, Arial',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Spiegel';
          src: local('Spiegel'), local('Spiegel'), url('public/res/spiegel.ttf) format('ttf');
        }
      `,
    },
  },
  palette: {
    primary: { main: '#000000'},
    secondary: { main: '#FFFFFF'},
    mariano: { 
      main: '#0A57A3',
      secondary: '#fbca83',
      terciary: '#fbca8366'
    },
    btnStyle: {
      main: '#fbca83',
    }
  },
};

// const blueTheme = {
//   ...orangeTheme,
//   palette: {
//     primary: { main: '#0A57A3' },
//     secondary: { main: '#000000' },
//     mariano: {
//       main: '#121212',
//       secondary: '#0A57A3',
//       terciary: '#0A57A344'
//     },
//     btnStyle: {
//       main: '#fbc02d',
//     },
//   },
// };

function App() {
  const [theme, setTheme] = useState(createTheme(orangeTheme));

  // const toggleTheme = () => {
  //   setTheme((prevTheme) => prevTheme.palette.primary.main === '#000000' ? createTheme(blueTheme) : createTheme(orangeTheme));
  // };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Outlet/>
    </ThemeProvider>
  );
}

export default App;
